import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { Placement } from '@popperjs/core';

import { ShareThumbnailOptions } from '../thumbnail-options';

interface Props {
  onUploadClicked: () => void;
  isNeueActive: boolean;
}

export const ShareThumbnailHoverOverlay = ({ onUploadClicked, isNeueActive }: Props) => {
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const menuPlacementRef = useRef<Placement>();

  const onMenuOpen = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    setKeepMenuOpen(true);
  };

  const onMenuClose = () => {
    setKeepMenuOpen(false);
  };

  return (
    <div
      className={classNames(
        'absolute inset-0 rounded-lg transition duration-200 ease-in-out group-hover:block group-hover:bg-bedrock-black/backdrop',
        !keepMenuOpen ? 'hidden' : 'block bg-bedrock-black/backdrop'
      )}
    >
      <div className='flex flex-col justify-between w-full h-full items-start p-4'>
        <div className='text-bedrock-p-small text-bedrock-white'>
          This is how your Journey will look when you share it. All links use the same thumbnail.
        </div>
        <ShareThumbnailOptions
          onOpen={onMenuOpen}
          onClose={onMenuClose}
          onUploadClicked={onUploadClicked}
          nestedMenuPlacement={menuPlacementRef.current}
          isNeueActive={isNeueActive}
        />
      </div>
    </div>
  );
};
